import { StatsHero } from '@/components/Analytics/StatsHero';

export default function AnalyticsPage() {
  return (
    <main className="min-h-screen bg-background">
      <StatsHero />
      
      <section className="container mx-auto px-4 py-12">
        <div className="w-full aspect-[16/9] pixel-border bg-card">
          <iframe
            src="/report/report.html"
            className="w-full h-full border-0"
            title="NFT Analytics Dashboard"
          />
        </div>
      </section>
    </main>
  );
} 